import logo from './logo.svg';
// import './App.css';
import NgoLandingPage from './component/NgoLandingPage';

function App() {
  return (
    <div className="App">
      <NgoLandingPage />
    </div>
  );
}

export default App;
